export const Globe = function (container, urls, contrle) {
  var rotAuto = true;
  var rotationSelf = false;

  var w;
  var h;
  var PI = Math.PI;
  var PI_HALF = PI / 2;

  // Three.js objects
  var camera;
  var scene;
  var light;
  var renderer;

  var earth;
  var earthGeometry;
  var earthPosition;

  //   this.rotAuto = true;

  var that = this;

  // camera's distance from center (and thus the globe)
  var distanceTarget = 900;
  var distance = distanceTarget;

  // camera's position
  var rotation = { x: 2, y: 1 };
  var target = { x: 2, y: 0 };

  // holds currently levitating blocks
  var levitatingBlocks = [];
  // holds all block references
  var blocks = [];

  // var globeBox = document.getElementById("globeBox");
  // What gets exposed by calling:
  //
  //    var globe = [new] Globe(div, urls);
  //
  // attach public functions to this object
  var api = {};

  // Spawns the globe
  api.init = function () {
    setSize();

    // Camera
    camera = new THREE.PerspectiveCamera(30, w / h, 1, 1000);
    camera.position.z = distance;
    camera.name = "Camera";

    // Scene
    scene = new THREE.Scene();
    scene.name = "Main Scene";
    window.scene = scene;
    scene.position.x = 0;
    scene.position.y = 0;
    scene.position.z = 0;

    scene.scale.x = scene.scale.y = scene.scale.z = 0.85;
    target.x = 1.01384;
    target.y = -0.1168;

    // Earth geom, used for earth & atmosphere
    earthGeometry = new THREE.SphereGeometry(115, 64, 64);

    // Light, reposition close to camera
    light = createMesh.directionalLight();
    light.name = "Sun Light";

    // we use this to correctly position camera and blocks
    earth = createMesh.earth(urls);
    earthPosition = earth.position;
    earth.name = "Earth";
    earth.rotation.y = 3.0;
    // Add meshes to scene
    scene.add(earth);
    scene.add(createMesh.atmosphere());

    // Add lights to scene
    scene.add(new THREE.AmbientLight(0xffffff));
    scene.add(light);

    // Renderer
    renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true,
    });
    renderer.setSize(w, h);
    renderer.autoClear = true;
    renderer.setClearColor(0xffffff, 0);

    renderer.name = "renderer";
    // Add scene to DOM
    renderer.domElement.style.position = "absolute";
    renderer.domElement.style.top = '0px';
    renderer.domElement.style.left = '0px';
    container.appendChild(renderer.domElement);

    // DOM event handlers
    // contrle.addEventListener('mousewheel', handle.scroll, false);

    contrle.addEventListener("touchstart", handle.drag.start, false);
    contrle.addEventListener(
      "touchstart",
      function () {
        // $("#dot").hide();
        // $("#dotTxt").hide();
      },
      false
    );
    window.addEventListener("resize", handle.resize, false);

    // Bootstrap render
    animate();
    return this;
  };

  var setSize = function () {
    w = container.offsetWidth || window.innerWidth;
    h = container.offsetHeight || window.innerHeight;
    // globeBox.style.width = h * 0.66 + "px";
    // globeBox.style.marginLeft = -(h * 0.66) / 2 + "px";
    // globeBox.style.marginTop = -(h * 0.93) / 2 + "px";
    //console.log(globeBox.style.width = '50%')
    /*w = 375;
        h = 600;*/
  };

  var createMesh = {
    // @param urls Object URLs of images
    //
    //  {
    //    earth: String URL
    //    bump: Sting URL [optional]
    //    specular: String URL [optional]
    //  }
    //
    // See
    // @link http://learningthreejs.com/blog/2013/09/16/how-to-make-the-earth-in-webgl/
    // @link http://learningthreejs.com/data/2013-09-16-how-to-make-the-earth-in-webgl/demo/index.html
    earth: function (urls) {
      if (!urls.earth) throw "No image URL provided for an earth image";

      var material = new THREE.MeshPhongMaterial();
      material.map = THREE.ImageUtils.loadTexture(urls.earth);

      if (urls.bump) {
        material.bump = THREE.ImageUtils.loadTexture(urls.bump);
        material.bumpScale = 0.02;
      }

      if (urls.specular) {
        material.specularMap = THREE.ImageUtils.loadTexture(urls.specular);
        material.specular = new THREE.Color("grey");
      }

      return new THREE.Mesh(earthGeometry, material);
    },

    // See
    // @link https://github.com/dataarts/webgl-globe/blob/master/globe/globe.js#L52
    // @link http://bkcore.com/blog/3d/webgl-three-js-animated-selective-glow.html
    //
    // Currently has some issues, especially when zooming out (distance > 900)
    // 创建大气层
    atmosphere: function () {
      var material = new THREE.ShaderMaterial({
        vertexShader: [
          "varying vec3 vNormal;",
          "void main() {",
          "vNormal = normalize( normalMatrix * normal );",
          "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
          "}",
        ].join("\n"),
        fragmentShader: [
          "varying vec3 vNormal;",
          "void main() {",
          "float intensity = pow( 0.8 - dot( vNormal, vec3( 0, 0, 1.0 ) ), 7.0 );",
          "gl_FragColor = vec4( 0.05, 0.05, 0.06, 0 ) * intensity;",
          "}",
        ].join("\n"),
        side: THREE.BackSide,
        blending: THREE.AdditiveBlending,
        transparent: false,
      });

      var mesh = new THREE.Mesh(earthGeometry, material);
      mesh.scale.set(1.1, 1.1, 1.1);
      return mesh;
    },
    // 创建定向光
    directionalLight: function () {
      var dLight = new THREE.DirectionalLight(0x000000);
      dLight.position.x = 3388;
      dLight.position.y = 388;
      dLight.position.z = -0.8;
      dLight.intensity = 1.08;
      // directionalLight
      dLight.name = "directional";
      // scene.add(directionalLight);

      return dLight;

      //return new THREE.DirectionalLight(0xffffff, 1.32);
    },
    // 创建光点
    block: function (color) {
      return new THREE.Mesh(
        new THREE.BoxGeometry(1, 1, 1),
        //new THREE.SphereGeometry(8, 8, 8),

        new THREE.MeshLambertMaterial({ color: color })
      );
    },
  };

  // Keep track of mouse positions
  var mouse = { x: 0, y: 0 };
  var mouseOnDown = { x: 0, y: 0 };
  var targetOnDown = { x: 0, y: 0 };

  // DOM event handlers
  var handle = {
    scroll: function (e) {
      e.preventDefault();
      api.zoomRelative(e.wheelDeltaY * 0.3);
      return false;
    },

    resize: function (e) {
      setSize();
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
    },

    // See
    // @link https://github.com/dataarts/webgl-globe/blob/master/globe/globe.js#L273-L334
    drag: {
      start: function (e) {
        e.preventDefault();
        contrle.addEventListener("touchmove", handle.drag.move, false);
        contrle.addEventListener("touchend", handle.drag.end, false);
        /*container.addEventListener('mouseout', handle.drag.end, false);*/

        mouseOnDown.y = -event.changedTouches[0].clientX;
        mouseOnDown.x = -event.changedTouches[0].clientY;
        /*mouseOnDown.x = -event.clientX;
                mouseOnDown.y = event.clientY;*/

        targetOnDown.x = target.x;
        targetOnDown.y = target.y;

        container.style.cursor = "move";
      },
      move: function (e) {
        mouse.y = -event.changedTouches[0].clientX;
        mouse.x = -event.changedTouches[0].clientY;

        var zoomDamp = distance / 1000;

        target.x =
          targetOnDown.x + (mouse.x - mouseOnDown.x) * 0.005 * zoomDamp;
        target.y =
          targetOnDown.y + (mouse.y - mouseOnDown.y) * 0.005 * zoomDamp;

        target.y = target.y > PI_HALF ? PI_HALF : target.y;
        target.y = target.y < -PI_HALF ? -PI_HALF : target.y;
      },
      end: function (e) {
        contrle.removeEventListener("touchmove", handle.drag.move, false);
        contrle.removeEventListener("touchend", handle.drag.end, false);
        /*container.removeEventListener('mouseout', handle.drag.end, false);*/
        container.style.cursor = "auto";
      },
    },
  };

  var checkAltituteBoundries = function () {
    // max zoom
    if (distanceTarget < 300) distanceTarget = 300;
    // min zoom
    else if (distanceTarget > 900) distanceTarget = 900;
  };

  var animate = function () {
    requestAnimationFrame(animate);
    render();
  };

  var render = function () {
    levitateBlocks();
    if (rotAuto) {
      if (earth.rotation.y < 6.28) {
        earth.rotation.y += 0.002;
      } else {
        earth.rotation.y = 0;
      }
      //   if (target.x <= 0) {
      //     target.x = 2;
      //   } else {
      //     target.x -= 0.002;
      //   }
    }

    if (rotationSelf) {
      target.x -= 0.001;
    }

    // Rotate towards the target
    rotation.x += (target.x - rotation.x) * 0.1;
    rotation.y += (target.y - rotation.y) * 0.1;
    distance += (distanceTarget - distance) * 0.3;

    // determine camera position
    set3dPosition(camera, {
      x: rotation.x,
      y: rotation.y,
      altitude: distance,
    });

    // Determine light position based
    set3dPosition(light, {
      x: rotation.x - 150,
      y: rotation.y - 150,
      altitude: distance,
    });

    camera.lookAt(earthPosition);

    renderer.render(scene, camera);
  };

  // @param Object position (2d lat/lon coordinates)
  // @return Object coords (x/y coordinates)
  //
  // Calculates x, y coordinates based on
  // lat/lon coordinates.
  var calculate2dPosition = function (coords) {
    var phi = ((90 + coords.lon) * PI) / 180;
    var theta = ((180 - coords.lat) * PI) / 180;
    return {
      x: phi,
      y: PI - theta,
    };
  };

  // @param Mesh object
  // @param Object coords (x/y coordinates in 2d space + altitute)
  //
  // Calculates 3d position and sets it on mesh
  var set3dPosition = function (mesh, coords) {
    if (!coords) coords = mesh.userData;

    var x = coords.x;
    var y = coords.y;
    var altitude = coords.altitude;

    mesh.position.set(
      altitude * Math.sin(x) * Math.cos(y),
      altitude * Math.sin(y),
      altitude * Math.cos(x) * Math.cos(y)
    );
  };

  var calculate3dPosition = function (coords) {
    var x = coords.x;
    var y = coords.y;
    var altitude = coords.altitude;

    return {
      x: altitude * Math.sin(x) * Math.cos(y),
      y: altitude * Math.sin(y),
      z: altitude * Math.cos(x) * Math.cos(y),
    };
  };

  // Create a block mesh and set its position in 3d
  // space just below the earths surface
  var createLevitatingBlock = function (properties) {
    // create mesh
    var block = createMesh.block(properties.color);

    // calculate 2d position
    var pos2d = calculate2dPosition(properties);

    block.userData = {
      // set 2d position on earth so we can more
      // easily recalculate the 3d position

      x: pos2d.x,
      y: pos2d.y,

      altitude: 115 - properties.size / 1.5,
      // speed at which block levitates outside
      // earth's core
      levitation: 0.1,

      size: properties.size,
    };

    // calculate 3d position
    set3dPosition(block);

    // rotate towards earth
    block.lookAt(earthPosition);

    block.scale.z = properties.size;
    block.scale.x = properties.size;
    block.scale.y = properties.size;

    block.updateMatrix();

    return block;
  };

  var createPointLight = function (properties) {
    // create mesh
    //var block = createMesh.block(properties.color);
    var pointColor = "#ffffff";
    var block = new THREE.PointLight(pointColor);
    block.distance = 15;
    block.intensity = 15;

    // calculate 2d position
    var pos2d = calculate2dPosition(properties);

    block.userData = {
      // set 2d position on earth so we can more
      // easily recalculate the 3d position

      x: pos2d.x,
      y: pos2d.y,

      altitude: 115 - properties.size / 1.5,
      // speed at which block levitates outside
      // earth's core
      levitation: 0.1,

      size: properties.size,
    };

    // calculate 3d position
    set3dPosition(block);

    // rotate towards earth
    block.lookAt(earthPosition);

    block.scale.z = properties.size;
    block.scale.x = properties.size;
    block.scale.y = properties.size;

    block.updateMatrix();

    return block;
  };

  // Create a block mesh and set its position in 3d
  // space just below the earths surface
  var createBlock = function (properties) {
    // create mesh
    var block = createMesh.block(properties.color);

    // calculate 2d position
    var pos2d = calculate2dPosition(properties);

    // add altitute
    pos2d.altitude = 115 + properties.size / 2;

    // calculate 3d position
    set3dPosition(block, pos2d);

    // rotate towards earth
    block.lookAt(earthPosition);

    block.scale.z = properties.size;
    block.scale.x = properties.size;
    block.scale.y = properties.size;

    block.updateMatrix();

    return block;
  };

  // internal function to levitate all levitating
  // blocks each tick. Called on render.
  var levitateBlocks = function () {
    levitatingBlocks.forEach(function (block, i) {
      var userData = block.userData;

      // if entirely outide of earth, stop levitating
      if (userData.altitude > 115 + userData.size / 2) {
        levitatingBlocks.splice(i, 1);
        return;
      }

      userData.altitude += userData.levitation;
      set3dPosition(block);
      block.updateMatrix();
    });
  };

  //        Public functions

  // @param int delta
  //
  // Zoom the earth relatively to its current zoom.
  // (passing a positive number will zoom towards
  // the earth, while a negative number will zoom
  // away from earth)
  api.zoomRelative = function (delta) {
    distanceTarget -= delta;

    checkAltituteBoundries();

    return this;
  };

  // @param int altitute
  //
  // Transition the altitute of the camera to a specific
  // distance from the earth's core.
  api.zoomTo = function (altitute) {
    distanceTarget = altitute;
    checkAltituteBoundries();

    return this;
  };

  // @param int altitute
  //
  // Set the altitute of the camera to a specific
  // distance from the earth's core.
  api.zoomImmediatelyTo = function (altitute) {
    distanceTarget = distance = altitute;
    checkAltituteBoundries();

    return this;
  };

  // @param Object coordinates

  //  {
  //    lat: (Float) latitute position,
  //    lon: (Float) longtitute position
  //  }

  // Transition the globe from its current position
  // to the new coordinates.
  api.center = function (pos) {
    target = calculate2dPosition(pos);
    return this;
  };

  // @param Object coordinates
  //
  //  {
  //    lat: (Float) latitute position,
  //    lon: (Float) longtitute position
  //  }
  //
  // Center the globe on the new coordinates.
  api.centerImmediate = function (pos) {
    target = rotation = calculate2dPosition(pos);
    return this;
  };

  // @param Object data
  //
  //  {
  //    lat: (Float) latitute position,
  //    lon: (Float) longtitute position,
  //    size: (Float) size of block,
  //    color: (String) color of block
  //  }
  //
  //  Adds a block to the globe. The globe will spawn
  //  just below the earth's surface and `levitate`
  //  out of the surface until it is fully `out` of the
  //  earth.
  api.addLevitatingBlock = function (data) {
    var block = createLevitatingBlock(data);

    var pointLight = createPointLight(data);
    scene.add(pointLight);
    levitatingBlocks.push(pointLight);
    blocks.push(pointLight);

    scene.add(block);
    levitatingBlocks.push(block);
    blocks.push(block);
    return this;
  };

  // @param Object data
  //
  //  {
  //    lat: (Float) latitute position,
  //    lon: (Float) longtitute position,
  //    size: (Float) size of block,
  //    color: (String) color of block
  //  }
  //
  //  Adds a block to the globe.
  api.addBlock = function (data) {
    var block = createBlock(data);
    block.name = data.name;
    scene.add(block);
    blocks.push(block);

    return this;
  };

  // Remove all blocks from the globe.
  api.removeAllBlocks = function () {
    blocks.forEach(function (block) {
      scene.remove(block);
    });

    blocks = [];

    return this;
  };

  api.setToStart = function (callback) {
    TweenLite.to(scene.position, 4, {
      x: 0,
      y: 0,
      z: 0,
      ease: Ease.easeOut,
      onComplete: function onComplete() {},
    });
    TweenLite.to(scene.scale, 4, {
      x: 1,
      y: 1,
      z: 1,
      ease: Ease.easeOut,
      onComplete: function onComplete() {},
    });
    TweenLite.to(earth.rotation, 4, {
      x: 0,
      y: 6.28,
      z: 0,
      ease: Ease.easeOut,
      onComplete: function onComplete() {
        // earth.rotation.x = 1;
        earth.rotation.y = 0;
        // earth.rotation.z = 0.6;
        rotAuto = false;
        if (callback) {
          callback();
        }
      },
    });
  };

  return api;
};